import * as o from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/ThreadsLogo.es.js";
const e = o.forwardRef((r, a) => /* @__PURE__ */ o.createElement(s, { ref: a, ...r, weights: t }));
e.displayName = "ThreadsLogoIcon";
const n = e;
export {
  n as ThreadsLogo,
  e as ThreadsLogoIcon
};
